import { useState } from 'react';
import { nanoid } from 'nanoid/non-secure';
import '../../utils/assertions.es.js';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import { useEnhancedEffect } from '../../utils/useEnhancedEffect.es.js';
import 'react-is';

const useId = (staticId) => {
  const [uuid, setUuid] = useState("");
  useEnhancedEffect(() => {
    setUuid(nanoid());
  }, []);
  return staticId || uuid;
};

export { useId };
//# sourceMappingURL=useId.es.js.map
